<template>
  <v-dialog
    v-model="show"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title>
        Jira Access
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-4">
        Please fill all the fields to get the access to the Jira REST API.
        To get API Token go to the
        <a href="https://id.atlassian.com/manage-profile/security/api-tokens" target="_blank" rel="noopener noreferrer" class="px-1">API Tokens manager</a>
        and create new one. After that paste your token to the "Jira API Token" field.
        <v-text-field
          class="mt-5 pt-3"
          dense
          hide-details
          label="Jira login"
          v-model="jiraApiDefaultLogin"
        ></v-text-field>
        <v-text-field
          class="mt-5 pt-3"
          dense
          hide-details
          label="Jira API Token"
          type="password"
          v-model="jiraApiToken"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" @click="show = false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :disabled="!jiraApiDefaultLogin || !jiraApiToken"
          @click="saveJiraRestApiAccessInformation">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'JiraApiTokenDialog',
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      jiraApiDefaultLogin: null,
      jiraApiToken: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    this.jiraApiDefaultLogin = this.user.e_mail
  },
  methods: {
    saveJiraRestApiAccessInformation () {
      this.jiraApiTokenDialog = false
      this.axios.post('/api/integrations/jira-access', {
        Employee_ID: this.user.employee_id,
        Jira_Login: this.jiraApiDefaultLogin,
        API_Token: this.jiraApiToken
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$emit('successSaved')
        this.show = false
        this.$store.dispatch('setSuccess', { successMsg: 'Your access information successfully saved' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
